module.exports = __webpack_public_path__ + "img/president_message_sc.99ac91f.webp";